import { Icon, IconProps } from ".";

export const Arrest = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M25.1457 9.16699H22.4554V11.8565H25.1457V9.16699Z" />
        <path d="M30.4731 11.8299H27.7828V14.5193H30.4731V11.8299Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.1457 14.4927V25.1442H27.8094V27.8337H9.13685V25.1442H11.8006V14.4927H25.1457ZM14.4909 17.1822H17.128V25.1442H14.4909V17.1822Z"
        />
        <path d="M27.7828 17.1556H30.4731V19.8451H27.7828V17.1556Z" />
        <path d="M11.8006 9.16699H14.4909V11.8565H11.8006V9.16699Z" />
        <path d="M9.16349 11.8299H6.47314V14.5193H9.16349V11.8299Z" />
        <path d="M6.47314 17.1556H9.16349V19.8451H6.47314V17.1556Z" />
      </>
    </Icon>
  );
};
